import React from "react";
import Link from "next/link";
import Image from "next/image";

interface IProps {
    className: string;
    imageUrl: string;
    href: string;
}

export const Logo = (props: IProps) => {
    if (props.href.includes("http")) {
        return (
            <a href={props.href} target="_blank" rel="noreferrer">
                <div className={props.className}>
                    <Image
                        src={props.imageUrl}
                        alt="logo"
                        layout="fill"
                        objectFit="contain"
                        priority
                    ></Image>
                </div>
            </a>
        );
    }

    return (
        <Link
            href={{
                pathname: props.href,
            }}
            passHref
        >
            <div className={props.className}>
                <Image
                    src={props.imageUrl}
                    alt="logo"
                    layout="fill"
                    objectFit="contain"
                ></Image>
            </div>
        </Link>
    );
};

export default Logo;
